import React from 'react';
import './services.css';

const Services = () => {
    return (
        <section id="services" className="services">
            <h2>Our Services</h2>
            <ul>
                <li>Structural Engineering</li>
                <li>Project Management</li>
                <li>Building Design</li>
                <li>Site Inspection</li>
            </ul>
        </section>
    );
};

export default Services;
